import { call, put, takeLatest } from "redux-saga/effects";
import {
  wholesalerAddSuccess,
  wholesalerAddFailure,
  wholesalerEditSuccess,
  wholesalerEditFailure,
  wholesalerDeleteSuccess,
  wholesalerDeleteFailure,
  wholesalerViewSuccess,
  wholesalerViewFailure,
  wholesalerViewAllSuccess,
  wholesalerViewAllFailure,
  wholesalerSearchViewAllFailure,
  wholesalerSearchViewAllSuccess,
} from "./WholesalerAction";

import {
  WHOLESALER_ADD_REQUEST,
  WHOLESALER_EDIT_REQUEST,
  WHOLESALER_DELETE_REQUEST,
  WHOLESALER_VIEW_REQUEST,
  WHOLESALER_VIEW_ALL_REQUEST,
  WHOLESALER_SEARCH_REQUEST,
} from "./WholesalerTypes";

import {
  AddWholesalerEffect,
  EditWholesalerEffect,
  DeleteWholesalerEffect,
  ViewWholesalerEffect,
  ViewAllWholesalersEffect,
  ViewAllSearchWholesalersEffect,
} from "./WholesalerEffect";

//Add Wholesaler
function* addWholesalerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(AddWholesalerEffect, action.payload, config);
    yield put(wholesalerAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add wholesaler";
    yield put(
      wholesalerAddFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Edit Wholesaler
function* editWholesalerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { id, updatedData } = action.payload;
    const response = yield call(EditWholesalerEffect, id, updatedData, config);

    yield put(wholesalerEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message =
      error.response?.data?.message ||
      "Failed to update wholesaler information";

    yield put(wholesalerEditFailure({ message, errorFields }));
  }
}

// View Wholesaler
function* viewWholesalerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(ViewWholesalerEffect, action.payload, config);
    yield put(wholesalerViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch wholesaler details";
    yield put(wholesalerViewFailure({ errormessage: errorMessage }));
  }
}

// View All Wholesalers
function* viewAllWholesalersSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(
      ViewAllWholesalersEffect,
      action.payload,
      config
    );
    yield put(wholesalerViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch wholesalers";
    yield put(wholesalerViewAllFailure({ errormessage: errorMessage }));
  }
}

// View All Search Wholesaler
function* viewAllSearchWholesalerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllSearchWholesalersEffect, action.payload, config);

    yield put(wholesalerSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerSearchViewAllFailure({ errormessage: errorMessage }));
  }
}


// Delete Wholesaler
function* deleteWholesalerSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const response = yield call(DeleteWholesalerEffect, action.payload, config);
    yield put(wholesalerDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete wholesaler";
    yield put(wholesalerDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* WholesalerSaga() {
  yield takeLatest(WHOLESALER_ADD_REQUEST, addWholesalerSaga);
  yield takeLatest(WHOLESALER_EDIT_REQUEST, editWholesalerSaga);
  yield takeLatest(WHOLESALER_DELETE_REQUEST, deleteWholesalerSaga);
  yield takeLatest(WHOLESALER_VIEW_REQUEST, viewWholesalerSaga);
  yield takeLatest(WHOLESALER_VIEW_ALL_REQUEST, viewAllWholesalersSaga);
  yield takeLatest(WHOLESALER_SEARCH_REQUEST, viewAllSearchWholesalerSaga);
}
